module.exports = __webpack_public_path__ + "static/Terminal_DarkMoon.26f1436b91592a5deca781a4e00add29.png";